import { makeStyles, Zoom } from "@material-ui/core"
import useScrollTrigger from "@material-ui/core/useScrollTrigger"
import React from "react"

export default function ScrollTop(props) {

    const useStyles = makeStyles((theme) => ({
        root: {
          zIndex: 9999,
          position: "fixed",
          bottom: theme.spacing(2),
          right: theme.spacing(2),
        },
      }))
    
    const { children, window } = props
    const classes = useStyles()
    // Note that you normally won't need to set the window ref as useScrollTrigger
    // will default to window.
    // This is only being set here because the demo is in an iframe.
    const trigger = useScrollTrigger({
      target: window ? window() : undefined,
      disableHysteresis: true,
      threshold: 100,
    })
  
    const handleClick = (event) => {
      const anchor = (event.target.ownerDocument || document).querySelector("#back-to-top-anchor")
      if (anchor) {
        anchor.scrollIntoView({ behavior: "smooth" })
      }
    }
  
    return (
      <Zoom in={trigger}>
        <div onClick={handleClick} role="presentation" className={classes.root}>
          {children}
        </div>
      </Zoom>
    )
  }